module.exports = __webpack_public_path__ + "img/image_2.fd00a1f0.svg";